import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import myFunctions from '../../../myFunctions';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import { RestContext } from '../../MyContexts/Rest_Context';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import SelectImgDelay from '../../MySections/ImagesSetter/SelectImgDelay';
import RichTextComp from '../../MySections/TextEditor/RichText';

const SectItmBtn1Effects = (props) => {
    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);

    const [btn1Color, setBtn1Color] = useState(currentSingle.btn1Color);
    const [btn1ForeColor, setBtn1ForeColor] = useState(currentSingle.btn1ForeColor);
    const [btn1Effect, setBtn1Effect] = useState(currentSingle.btn1Effect);
    const [btn1delay, setBtn1delay] = useState(currentSingle.btn1delay);
    const [btn1duration, setBtn1duration] = useState(currentSingle.btn1duration);


    useEffect(() => {

    }, [])
    return (
        <>
            <div className={"col-md-6 mb-2 onRight"}>
                <div className={"fullRow"}>
                    <div className={"col-md-4 mb-2 onRight"}>
                        <label>צבע כפתור</label>
                        <div className={"input-group"}>
                            <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"#fffff"} value={btn1Color} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn1Color = e.target.value; setBtn1Color(e.target.value) }} required />

                        </div>
                    </div>
                    <div className={"col-md-4 mb-2 onRight"}>
                        <label>צבע טקסט כפתור</label>
                        <div className={"input-group"}>
                            <input type={"text"} className={"form-control"} id={"validationCustom052"} placeholder={"#fffff"} value={btn1ForeColor} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn1ForeColor = e.target.value; setBtn1ForeColor(e.target.value) }} required />

                        </div>
                    </div>
                    <div className={"col-md-4 mb-2 onRight"}>
                        <label>אפקט</label>
                        <div className={"input-group"}>
                            <select defaultValue={btn1Effect} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn1Effect = e.target.value; setBtn1Effect(e.target.value) }}>

                                {myFunctions.animateList().map((itm, indx) => {
                                    return (
                                        <option key={indx}>
                                            {itm}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={"fullRow"}>
                    <div className={"col-md-6 mb-2 onRight"}>
                        <label>Duration (0-5)</label>
                        <div className={"input-group"}>
                            <input type={"number"} max={5} min={0} className={"form-control"} id={"validationCustom02"} placeholder={""} value={btn1duration} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn1duration = e.target.value; setBtn1duration(e.target.value) }} required />

                        </div>
                    </div>
                    <div className={"col-md-6 mb-2 onRight"}>
                        <label>Delay</label>
                        <div className={"input-group"}>
                            <SelectImgDelay currentDelay={btn1delay ? btn1delay : ""}
                                theFunction={(fUrl) => { currentSingle.btn1delay = fUrl; setBtn1delay(fUrl) }} />
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default SectItmBtn1Effects;